import { Route, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AcessoNegadoComponent } from './core/acesso-negado/acesso-negado.component';
import { AssinaturaGuard } from './dashboard/services/assinatura.guard';
import { LayoutComponent } from './layout/layout/layout.component';
import { AuthGuard } from './seguranca/auth.guard';
import { PagamentoFaturaPageComponent } from './view/financeiro/pagamento-fatura-page/pagamento-fatura-page.component';
import { NovoCadastroComponent } from './view/novo-cadastro/novo-cadastro.component';
import { AssinaturaPageComponent } from './view/outros/assinatura-page/assinatura-page.component';

/**
 * UI Kit routes — showcase das variantes dos componentes PrimeNG
 * servindo como validação viva dos tokens do orange.preset.ts.
 * Só registradas em dev/homologação (`environment.production === false`)
 * para o bundle de prod não carregar esse código.
 */
const uiKitRoute: Route = {
  path: 'ui-kit',
  loadChildren: () =>
    import('./view/ui-kit/ui-kit.routes').then((m) => m.UI_KIT_ROUTES),
  canActivate: [AuthGuard],
};

export const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'cadastros',
    loadChildren: () =>
      import('./view/cadastros/cadastros.routes').then(
        (m) => m.CADASTROS_ROUTES,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'financeiro',
    loadChildren: () =>
      import('./view/financeiro/financeiro.routes').then(
        (m) => m.FINANCEIRO_ROUTES,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'comercial',
    loadChildren: () =>
      import('./view/comercial/comercial.routes').then(
        (m) => m.COMERCIAL_ROUTES,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'suprimentos',
    loadChildren: () =>
      import('./view/suprimentos/suprimento.routes').then((m) => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: 'fiscal',
    loadChildren: () =>
      import('./view/fiscal/fiscal.routes').then((m) => m.FISCAL_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'contabil',
    loadChildren: () =>
      import('./view/contabil/contabil.routes').then((m) => m.CONTABIL_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'gerencial',
    loadChildren: () =>
      import('./view/gerencial/gerencial.routes').then(
        (m) => m.GERENCIAL_ROUTES,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'configuracoes',
    loadChildren: () =>
      import('./view/configuracao/configuracao.routes').then(
        (m) => m.CONFIGURACAO_ROUTES,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'relatorios',
    loadChildren: () =>
      import('./view/relatorios/relatorios.routes').then(
        (m) => m.RELATORIOS_ROUTES,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'novo-cadastro',
    component: NovoCadastroComponent,
  },
  {
    path: 'assinatura',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: AssinaturaPageComponent,
        canActivate: [AssinaturaGuard],
      },
    ],
  },
  {
    path: 'fatura/:id',
    component: PagamentoFaturaPageComponent,
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () =>
      import('./seguranca/seguranca.routes').then((m) => m.SEGURANCA_ROUTES),
  },
  { path: 'acesso-negado', component: AcessoNegadoComponent },
  // { path: 'pagina-nao-encontrada', component: PaginaNaoEncontradaComponent },
  // { path: '**', redirectTo: 'pagina-nao-encontrada' }
];

// Inject UI Kit routes only in dev/homologação. Em prod, production=true
// e essa rota não entra no array — o bundler faz tree-shake dos imports
// que não forem alcançáveis a partir das rotas registradas.
if (!environment.production) {
  routes.unshift(uiKitRoute);
}
